import React, { useRef, useState } from "react";

import { CloseIcon as Close, SearchIcon as Search } from "@packages/ds";

import * as S from "./SearchInput.styles";

export type SearchInputProps = {
  onChange: (search: string) => void;
};

export const SearchInput = ({ onChange }: SearchInputProps) => {
  const [value, setValue] = useState("");
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  const _onChange = (_value: string) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      onChange(_value);
    }, 500);

    setValue(_value);
  };

  const hasValue = !!value;

  return (
    <S.SearchInputRoot>
      <Search fill="var(--granite)" />

      <S.SearchInput
        placeholder="Search"
        value={value}
        onChange={event => {
          _onChange(event.target.value);
        }}
      />

      {hasValue && (
        <Close
          fill="var(--granite)"
          onClick={() => {
            _onChange("");
          }}
        />
      )}
    </S.SearchInputRoot>
  );
};
